import React from 'react';

function Footer(){
    return (
        <React.Fragment>
			<footer className="sticky-footer bg-white">
				<div className="container my-auto">
					<div className="copyright text-center my-auto">
						<span>Copyright &copy; Gurpo-8 Rayuela Dashboard 2022</span>
					</div>
				</div>
			</footer>

        </React.Fragment>
    )
}
export default Footer;